module.exports = __webpack_public_path__ + "img/hohlschnitt_beige_ral1014.d4dc24cc.jpg";